// Nomination Settings — frontend mirror of showman-db-v1/src/utils/nominations.js.
// Shapes what the exhibitor UI offers; the backend enforces the same rules on
// add / edit / create-group.
//
// A nomination is an animal confirmed in an exhibitor's name before online entries
// open. Shows call the same record a nomination, a validation or an intention; the
// code, data and admin UI always say "nominations" and `label` picks the
// exhibitor-facing word.
//
// events.entry_settings.nominations = {
//   enabled,                 // this show uses nominations: exhibitors may only finish pre-loaded entries
//   label,                   // exhibitor-facing term: 'nomination' | 'validation' | 'intention'
//   allow_delete,            // after nominations close, exhibitor may scratch (soft delete) a nominated entry
//   allow_change_exhibitor,  // ... may move a nominated entry to another exhibitor on the account
//   open_entry_types,        // ... may add these entry type identifiers themselves (e.g. showmanship)
//   allow_new_exhibitors     // ... may add a NEW person when entering an open type (never on a nominated entry)
//   submissions_*            // online submission window before entries open: ./nominationSubmissions.js
// }

export const NOMINATION_LABEL_OPTIONS = [
  {label: 'Nomination', value: 'nomination'},
  {label: 'Validation', value: 'validation'},
  {label: 'Intention', value: 'intention'}
]

export function defaultNominationSettings () {
  return {
    enabled: false,
    label: 'nomination',
    allow_delete: true,
    allow_change_exhibitor: true,
    open_entry_types: [],
    allow_new_exhibitors: false,
    submissions_enabled: false,
    submissions_open_date: '',
    submissions_close_date: '',
    submissions_instructions: '',
    submissions_terms: ''
  }
}

// null when the event does not use nominations; otherwise a normalised copy.
export function getNominationSettings (entrySettings) {
  const n = entrySettings && entrySettings.nominations
  if (!n || !n.enabled) {
    return null
  }
  const known = NOMINATION_LABEL_OPTIONS.some(o => o.value === n.label)
  return {
    enabled: true,
    label: known ? n.label : 'nomination',
    allow_delete: n.allow_delete !== false,
    allow_change_exhibitor: n.allow_change_exhibitor !== false,
    open_entry_types: Array.isArray(n.open_entry_types) ? n.open_entry_types.filter(Boolean) : [],
    allow_new_exhibitors: n.allow_new_exhibitors === true
  }
}

// The exhibitor-facing word, e.g. nominationTerm(s, {plural: true}) → 'validations'.
export function nominationTerm (settings, options) {
  const opts = options || {}
  let term = (settings && settings.label) || 'nomination'
  if (opts.plural) {
    term += 's'
  }
  if (opts.capitalize) {
    term = term.charAt(0).toUpperCase() + term.slice(1)
  }
  return term
}

// Shown on Enter Show to an account with no entry group
export function noNominationsMessage (settings) {
  return `This account doesn't have any ${nominationTerm(settings, {plural: true})} submitted for this event.`
}

// A nominated type is any entry type not explicitly opened.
export function isNominatedType (settings, entryTypeIdentifier) {
  if (!settings) {
    return false
  }
  return settings.open_entry_types.indexOf(entryTypeIdentifier) === -1
}
